module.exports = __webpack_public_path__ + "img/pandaMainLogo.f03992bf.svg";